import { render, staticRenderFns } from "./ScrollToTop.vue?vue&type=template&id=4ebc1fb6&"
import script from "./ScrollToTop.vue?vue&type=script&lang=js&"
export * from "./ScrollToTop.vue?vue&type=script&lang=js&"
import style0 from "./ScrollToTop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports